import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className={`header-container ${scrolled ? 'floating-nav' : ''}`}>
        <div className="logo fade-in">
          <a href="/" className="glow">
            <img src="/favicon.svg" alt="Logo" className="logo-img" />
            <span className="logo-text">AminSweiti</span>
          </a>
        </div>
        <nav className="nav">
          <ul className="nav-list">
            <li className="fade-in delayed-1"><a href="#video-application" className="nav-link">Video Application</a></li>
            <li className="fade-in delayed-1"><a href="#projects" className="nav-link">Projects</a></li>
            <li className="fade-in delayed-2"><a href="#experience" className="nav-link">Experience</a></li>
            <li className="fade-in delayed-2"><a href="#skills" className="nav-link">Skills</a></li>
          </ul>
        </nav>
        <div className="auth-buttons">
          <a href="mailto:aminsweiti@gmail.com" className="btn btn-primary fade-in delayed-3">Hire Me</a>
        </div>
      </div>
    </header>
  );
};

export default Header; 